import React, { useState } from "react";
import "./Layout.scss";
import Dashboard from "./Dashboard/Dashboard";

const Layout = (props) => {
 
  return (
    <React.Fragment>
      {/* Global Header Component */}

      <main>{props.children}</main>
      {<Dashboard />}
     
    </React.Fragment>
  );
};

export default Layout;
